"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Utilities_1 = require("../../Utilities");
var DialogFooter_base_1 = require("./DialogFooter.base");
var DialogFooter_styles_1 = require("./DialogFooter.styles");
exports.DialogFooter = Utilities_1.styled(DialogFooter_base_1.DialogFooterBase, DialogFooter_styles_1.getStyles);
//# sourceMappingURL=DialogFooter.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib/components/Dialog/DialogFooter.js
// module id = 779
// module chunks = 0